import Vue from 'vue'
import VueRouter from 'vue-router'
import {getTenant, getToken} from "@/utils/auth";
import getPageTitle from "@/utils/get-page-title";
import NProgress from 'nprogress';
import store from '@/store';
import {USER_SET_CHECKED_USER_STATE} from "@/store/mutation-types";
import {saleRoutes} from "@/router/modules/sale";
import {settingRoutes} from "@/router/modules/setting";
import {warehouseRoutes} from "@/router/modules/warehouse";
import {productRoutes} from "@/router/modules/product";
import {adRoutes} from "@/router/modules/ad";
import {crmRoutes} from "@/router/modules/crm";
import {financeRoutes} from "@/router/modules/finance";
import {systemRoutes} from "@/router/modules/system";
import {logisticsRoutes} from "@/router/modules/logistics";
import {statisticsRoutes} from "@/router/modules/statistics";
import {messageRoutes} from "@/router/modules/message";
import {isMeaningful} from "@/utils/common";
import {USER_GET_INFO, USER_RESET_USER} from "@/store/action-types";
import {personalRoutes} from "@/router/modules/personalCenter";
import {toolRoutes} from "@/router/modules/tool";
import {homeRoutes} from "@/router/modules/home";
import {errorRoutes} from "@/router/modules/error";
import {PAGE_ROUTES} from "@/utils/const";
import {purchaseRoutes} from "@/router/modules/purchase";
import versionTood from '@/utils/versionUpdate'

Vue.use(VueRouter);

//路由名称不可重复
const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/pages/new-login/login'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    component: () => import('@/views/pages/login/login'),
    meta: { title: '预约演示' }
  },
  {
    path: '/manager-login',
    component: () => import('@/views/pages/manager-login/manager-login')
  },
  {
    path: '/retrieve-password',
    component: () => import('@/views/pages/retrieve-password/retrieve-password'),
    meta: { title: '忘记密码' }
  },
  {
    path: '/redirect',
    component: () => import('@/views/pages/redirect/redirect')
  },
  ...homeRoutes,
  ...saleRoutes,
  ...settingRoutes,
  ...warehouseRoutes,
  ...productRoutes,
  ...adRoutes,
  ...crmRoutes,
  ...financeRoutes,
  ...systemRoutes,
  ...logisticsRoutes,
  ...statisticsRoutes,
  ...toolRoutes,
  ...messageRoutes,
  ...personalRoutes,
  ...errorRoutes,
  ...purchaseRoutes,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/error/404' }
];

const createRouter = () => new VueRouter({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

const router = createRouter();

// 全局路由配置
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = PAGE_ROUTES; // no redirect whitelist

let startTime = 0;
let startTitle;
router.afterEach((to, from) => {
  // eslint-disable-next-line no-undef
  sensorsdata.quick('autoTrackSinglePage', {$title: to.meta.title || to.meta.name || getPageTitle(to.meta.title || to.meta.name)});
})
router.beforeEach(async (to, from, next) => {
  const millisecond = +new Date() - startTime;
  if (window._hmt && to.path) {
    window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  }
  if (to.path === '/manager-login') {
    await store.dispatch(USER_RESET_USER);
  }

  // start progress bar
  NProgress.start();
  if (startTitle) {
    // eslint-disable-next-line no-undef
    sensorsdata.track('stayDuration', {
      millisecond,
      second: +(millisecond / 1000).toFixed(),
      minute: +(millisecond / 1000 / 60).toFixed(2),
      pageTitle: startTitle
    });
  }
  startTime = new Date().getTime();
  // set page title
  document.title = to.meta.title || to.meta.name || getPageTitle(to.meta.title || to.meta.name);
  startTitle = document.title;
  // determine whether the user has logged in
  const token = getToken();
  const tenant = getTenant();

  if (isMeaningful(token) && isMeaningful(tenant)) {
    if (whiteList.indexOf(to.path) !== -1) {
      next({path: '/'});
      NProgress.done();
    } else {
      if (isMeaningful(store.getters.account)) {
        versionTood.isNewVersion();
        next();
      } else {
        try {
          await store.dispatch(USER_GET_INFO);
          versionTood.isNewVersion();
          next({...to, replace: true});
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch(USER_RESET_USER);
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      store.commit(USER_SET_CHECKED_USER_STATE, true);
      setTimeout(()=>{
        next();
      })
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach((to) => {
  // finish progress bar
  NProgress.done()
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  // const newRouter = createRouter();
  // router.matcher = newRouter.matcher // reset router
}

export default router
